import React from 'react'
import AddComponent from '../../components/qna/AddComponent'

const AddPage = () => {
  return (
    <>
      <div className='mb-5'>AddPage</div>
      <AddComponent />
    </>
  )
}

export default AddPage